export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_L3.fbf3c141.png";